// src/components/Campaigns/CampaignManager.jsx
import React, { useCallback } from "react";
import { Box } from "@mui/material";
import { toast } from "react-toastify";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import logo from '../../../../../assets/logo.png';
import COLORS from "../../../../../constants/colors";
import CampaignsTable from "./CampaignsTable";
import baseURL from "../../config";

// This component now receives 'campaigns' and 'onCampaignUpdated' as props
const CampaignManager = ({ campaigns, onCampaignUpdated }) => {
    // The handleDownloadLog function remains local to this component
    const handleDownloadLog = useCallback(async (campaignId, campaignName) => {
        try {
            const res = await fetch(`${baseURL}/user/campaigns/${campaignId}/donors`, {
                credentials: 'include'
            });

            const data = await res.json();

            if (!Array.isArray(data) || data.length === 0) {
                toast.error('No donor data available for this campaign.');
                return;
            }

            const doc = new jsPDF();
            doc.addImage(logo, 'PNG', 10, 10, 46, 20);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(12);
            doc.text(`Donation Log for: ${campaignName}`, 15, 35);

            const tableData = data.map((donor, index) => [
                index + 1,
                donor.donor_email,
                `UGX ${Number(donor.amount).toLocaleString()}`,
                new Date(donor.created_at).toLocaleString()
            ]);

            autoTable(doc, {
                startY: 40,
                head: [["#", "Email", "Donation", "Date"]],
                body: tableData,
                styles: { fontSize: 10 },
                headStyles: {
                    fillColor: COLORS.primary,
                    textColor: 255,
                    halign: 'left',
                },
                bodyStyles: {
                    textColor: [50, 50, 50],
                },
                columnStyles: {
                    0: { halign: 'center', cellWidth: 10 },
                    2: { halign: 'left' },
                    3: { halign: 'left' },
                },
            });

            const pdfBlob = doc.output('blob');
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');

        } catch (err) {
            console.error("Error downloading donor log:", err);
            toast.error("Failed to fetch donor log.");
        }
    }, []);

    return (
        <Box>
            <CampaignsTable
                campaigns={campaigns}
                onCampaignUpdated={onCampaignUpdated}
                handleDownloadLog={handleDownloadLog}
            />
        </Box>
    );
};

export default CampaignManager;